import React, { useEffect, useState } from "react"
import "./SingleBlogPage.scss"
import backgroundSrc from "../assets/bg.jpg"
import BlogItem from "../components/BlogItem/BlogItem"
import BlogDetailedPage from "../BlogDetailedPage/BlogDetailedPage"
import { getAllBlogPosts, getBlogPost } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests"
import { useParams } from "react-router"
import { useSelector } from "react-redux"

const SingleBlogPage = () => {
    const [data, setData] = useState([])
    const [post, setPost] = useState(null)
    let params = useParams();

    const [isLoading, setIsLoading] = useState(false)
    const [isPostsLoading, setIsPostsLoading] = useState(false)
    const companyDetails = useSelector((state) => state.companyData.company)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        fetchData()
    }, [params, params.id])
    const fetchData = async () => {
        setIsLoading(true)
        setIsPostsLoading(true)
        let id = companyDetails?.ID ?? ''

        await getBlogPost(params.id, id).then((response) => {
            if (response) {
                setPost(response)
            } else {
                setPost(null)
            }
            setIsLoading(false)

        })
        await getAllBlogPosts(id).then((response) => {
            if (response.data) {
                setData(response.data)
            } else {
                setData([])
            }
            setIsPostsLoading(false)
        })

    }
    return (
        <div className="SingleBlogPage">
            <div className="SingleBlogPage-hero" style={{
                backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
    linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
    linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${backgroundSrc})`
            }}>
                <div className="SingleBlogPage-hero-container">
                    <div className="SingleBlogPage-hero-container-wrapper">
                        <div className="SingleBlogPage-hero-header-cont">
                            <div className="SingleBlogPage-hero-header">VIRASAT BLOG</div>
                            <div className="SingleBlogPage-hero-subheader">OUR JOURNAL</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="SingleBlogPage-wrapper">
                {isLoading ? <div className="SingleBlogPage-wrapper-emptycontainer"><div className="loader-blog" /></div>
                    :
                    <div className="SingleBlogPage-wrapper-container">
                        <BlogDetailedPage
                            blog={post} />
                    </div>}
                <div className="SingleBlogPage-wrapper-container2">
                    <div className="SingleBlogPage-wrapper-container2-header">Related Posts</div>
                    <div className="SingleBlogPage-wrapper-container2-subheader">Explore more stories from our kitchen.</div>
                    {isPostsLoading ? <div className="loader-blog2" />
                        : <div className="SingleBlogPage-wrapper-container2-grid">
                            {data?.slice(0, 3)?.map((item, key) => {
                                return (
                                    <BlogItem
                                        key={key}
                                        item={item}
                                        isHome={false}
                                        isFilter />
                                )
                            })}

                        </div>}
                </div>
            </div>
        </div>
    )
}
export default SingleBlogPage